export enum ROUTES {
  ACCOUNT = "/billing",
  ACCOUNT_LATEST = "/billing/latest",
  BILLING_MANAGEMENT = "/billing/manage",
  BILLING_LATEST_MANAGEMENT = "/billing/latest/manage",
}
